import { useState, useEffect } from 'react';

function useEditingState() {
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        const handleFocusIn = (event: FocusEvent) => {
            const target = event.target as Element;
            if (target.matches('input, textarea, [contenteditable="true"], .djs-direct-editing-content')) {
                setIsEditing(true);
            }
        };

        const handleFocusOut = (event: FocusEvent) => {
            const target = event.target as Element;
            if (target.matches('input, textarea, [contenteditable="true"], .djs-direct-editing-content')) {
                //un piccolo delay per assicurarsi che il focus non si sposti su un altro campo (claude suggestion because bpmn stuff)
                setTimeout(() => {
                    const activeElement = document.activeElement;
                    if (!activeElement || !activeElement.matches('input, textarea, [contenteditable="true"], .djs-direct-editing-content')) {
                        setIsEditing(false);
                    }
                }, 10);
            }
        };

        const handleDirectEditingStart = () => {
            setIsEditing(true);
        };

        const handleDirectEditingEnd = () => {
            setIsEditing(false);
        };

        document.addEventListener('focusin', handleFocusIn);
        document.addEventListener('focusout', handleFocusOut);

        document.addEventListener('directEditing.activate', handleDirectEditingStart);
        document.addEventListener('directEditing.complete', handleDirectEditingEnd);
        document.addEventListener('directEditing.cancel', handleDirectEditingEnd);

        return () => {
            document.removeEventListener('focusin', handleFocusIn);
            document.removeEventListener('focusout', handleFocusOut);
            document.removeEventListener('directEditing.activate', handleDirectEditingStart);
            document.removeEventListener('directEditing.complete', handleDirectEditingEnd);
            document.removeEventListener('directEditing.cancel', handleDirectEditingEnd);
        };
    }, []);

    return isEditing;
}

export default useEditingState;